/* eslint-disable react/prop-types */
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import './SocialLinks.css';

const socialLinks = [
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/aunt.jacks.peanut.shack',
    Icon: FaFacebookF,
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/aunt_jack_peanut/',
    Icon: FaInstagram,
  },
];

function SocialLinks({ variant = 'default' }) {
  return (
    <div className={`social-links social-links--${variant}`} aria-label="Aunt Jack's social media">
      {socialLinks.map(({ name, url, Icon }) => (
        <a
          className='social-link'
          href={url}
          key={name}
          target='_blank'
          rel='noopener noreferrer'
          aria-label={`Follow Aunt Jack's Peanut Shack on ${name}`}
        >
          <Icon aria-hidden='true' focusable='false' />
          <span>{name}</span>
        </a>
      ))}
    </div>
  );
}

export default SocialLinks;
